module.exports = __webpack_public_path__ + "static/media/item_2_10ll.c90661ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_10ll.png
// module id = 127
// module chunks = 0